import { useState, useEffect } from 'react';
import axios, { AxiosError } from 'axios';

/**
 * Registers an Axios response interceptor that watches for 503 responses from
 * the Grieg API (any URL containing `${origin}/api`). Returns true once one is
 * detected, at which point the caller should render maintenance UI and suppress
 * further requests.
 */
export function useMaintenanceMode(): boolean {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);

  useEffect(() => {
    const id = axios.interceptors.response.use(
      (response) => response,
      (err: AxiosError) => {
        const wasGriegRequest = err?.config?.url?.includes(`${window.location.origin}/api`);
        const responseIs503 = err?.response?.status === 503;

        if (wasGriegRequest && responseIs503) setIsMaintenanceMode(true);

        return Promise.reject(err);
      },
    );

    return () => axios.interceptors.response.eject(id);
  }, []);

  return isMaintenanceMode;
}
